import { Skeleton } from '@reveni-io/reveni-ui'

import * as Styles from './styles'

const ReturnsAndExchangesRatioContentSkeleton = () => (
  <Styles.Container>
    <Styles.PieSection>
      <Skeleton variant="circular" width={200} height={200} />
      <Styles.LabelsRow>
        <Skeleton variant="text" width={100} height={20} />
        <Skeleton variant="text" width={100} height={20} />
      </Styles.LabelsRow>
    </Styles.PieSection>
    <Skeleton variant="rounded" width="100%" height={230} />
  </Styles.Container>
)

export default ReturnsAndExchangesRatioContentSkeleton
